import { setUpAPI } from '../../Utils/api.utils';

export const updateInfluencer = async (userId, enrollInfluencer) => {
    const data = {
        cmd: "iUserProfile_UpdateInfluencer",
        UserId: userId,
        enroll_influencer: enrollInfluencer
    }

    try {
        const response = await setUpAPI('mUserProfile', data, 'POST', null).catch((error) => {
            return error;
        });
        return response.json();
    } catch (error) {
        console.log('error', error)
    }

}